<template>
    <div v-show="isShow"
        class="tips"
        :class="isShowMask ? 'maskBgc' : ''">
        <!-- 去验证弹框内容 -->
        <div v-if="isShowGoCheck"
            class="content">
            <div class="title">{{verifyTitle}}</div>
            <div class="button">
                <!-- 大转盘（有参加其他活动按钮时） -->
                <div v-if="showOtherActivity"
                    class="show-other">
                    <div class="go-other common"
                        :class="{'button-style': !isShowCheckBtn}"
                        @click="goOtherActivity()">参加其他活动
                    </div>
                    <div v-if="isShowCheckBtn"
                        class="go-check common one-check"
                        @click="clickCheckIdentity()">去验证</div>
                </div>
                <!-- 专题活动、大转盘（无参加其他活动按钮时） -->
                <div v-else-if="isShowCheckBtn"
                    class="right one-check"
                    @click="clickCheckIdentity()">去验证</div>
                <div v-else
                    class="right right-close"
                    @click="close()">关闭</div>
            </div>
            <div v-show="isShowCheckBtn || showOtherActivity"
                class="closeImage"
                @click="close()">
                <img src="static/image/close.png"
                    alt="">
            </div>

        </div>
        <div v-if="isShowEdu"
            class="content">
            <!-- edu验证组件 -->
            <eduEducationCertification :isShowEdu="isShowEdu"
                :inputInfoPop="inputInfoPop"
                :cacheInvalidation="cacheInvalidation"
                :enterVerificationCode="enterVerificationCode"
                :elementParentObj="elementParentObj"
                :clickElementObj="clickElementObj"
                :clickIndex="clickIndex"
                :handleReceivecoupon="handleReceivecoupon"
                :receiveAward="receiveAward"
                :receiveEquityPackage="receiveEquityPackage"
                :pageSource="pageSource"
                :getAllData="getAllData"
                :oldUserInfo="oldUserInfo"
                @closeEdu="closeEdu"
                @changeBoundingBox="changeBoundingBox"></eduEducationCertification>
        </div>
        <select-methods ref="selectMethods"
            :identityTypeList="identityTypeList"
            :checkChannel="checkChannel"
            :elementParentObj="elementParentObj"
            :clickElementObj="clickElementObj"
            :clickIndex="clickIndex"
            :handleReceivecoupon="handleReceivecoupon"
            :receiveAward="receiveAward"
            :receiveEquityPackage="receiveEquityPackage"
            :loginType="loginType"
            :checkResultList="checkResultList"
            @close="close"
            @toVerify="toVerify"></select-methods>
    </div>
</template>
<script>
import { goIdentityVerification } from '../../../.././utils/comUtils.js';
import utils from '../../../.././utils/comUtils.js';
import eduEducationCertification from './eduEducationCertification.vue';
import { IdentityVerify, LoginType } from '../../../../commons/commonVariables.js';
import selectMethods from './selectMethods.vue';
import { Toast } from 'vant';
export default {
  components: { eduEducationCertification, selectMethods },
  props: {
    // 显示弹框
    isShowIdentityDialog: {
      type: Boolean,
      default: false,
    },
    // 弹框的内容
    verifyTitle: {
      type: String,
      default: '领取失败，该优惠券为【新用户】专享',
    },
    // 是否显示去参考其他活动的按钮
    showOtherActivity: {
      type: Boolean,
      default: false,
    },
    activityUrl: {
      type: String,
      default: '',
    },
    isShowCheckBtn: {
      type: Boolean,
      default: true,
    },
    activityCode: {
      type: String,
      default: '',
    },
    clickListId: {
      type: String,
      default: '',
    },
    clickIndex: {
      type: Number,
      default: null,
    },
    // 页面来源
    pageSource: {
      type: String,
      default: '',
    },
    // 是否点击了下级页面
    isClickNextPage: {
      type: String,
      default: '',
    },
    identityTypeList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    loginType: {
      type: String,
      default: '',
    },
    elementParentObj: {
      type: Object,
      default: () => {
        return {};
      },
    },
    clickElementObj: {
      type: Object,
      default: () => {
        return {};
      },
    },
    handleReceivecoupon: {
      type: Function,
      default: () => {
        return () => {};
      },
    },
    receiveAward: {
      type: Function,
      default: () => {
        return () => {};
      },
    },
    receiveEquityPackage: {
      type: Function,
      default: () => {
        return () => {};
      },
    },
    checkChannel: {
      type: Number,
      default: null,
    },
    getAllData: {
      type: Function,
      default: () => {
        return () => {};
      },
    },
    activityType: {
      type: String,
      default: '',
    },
    guideUserId: {
      type: String,
      default: '',
    },
    storeCode: {
      type: String,
      default: '',
    },
    activityName: {
      type: String,
      default: '',
    },
    checkResultList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    isShowIdentityDialog: {
      handler(val) {
        this.isShow = val;
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      isShow: false, //是否展示身份验证提示框
      activityUrlCopy: this.activityUrl,
      isShowEdu: false, //是否展示EDU验证弹框
      inputInfoPop: false, //从未认证过为true
      cacheInvalidation: false, //认证过但已过期失效时为true
      enterVerificationCode: false, //输入验证码弹框
      isShowGoCheck: true, //去验证弹框内容控制标识
      isShowMask: false, // 遮罩层颜色
      oldUserInfo: {
        id: '',
        userName: '',
        email: '',
        identity: '',
        university: '',
      },
    };
  },
  computed: {},
  created() {
    console.log('从祖父组件接受的参数', this.isShowIdentityDialog, this.verifyTitle);
  },
  mounted() {},
  methods: {
    // 关闭弹框
    close() {
      this.isShow = false;
      this.isShowMask = false;
      this.isShowGoCheck = true;
      // 父组件使用.sync结合使用，作为一个事件绑定语法糖，
      // 利用EventBus，当子组件触发事件时，父组件会响应事件并实现数据更新，避免了子组件直接修改父组件传过来的内容。
      this.$emit('update:isShowIdentityDialog', false);
    },
    closeEdu() {
      this.isShowEdu = false;
      this.inputInfoPop = false;
      this.cacheInvalidation = false;
      this.enterVerificationCode = false;
      this.isShowGoCheck = true;
      this.close();
    },
    changeBoundingBox(data) {
      this.inputInfoPop = data.inputInfoPop;
      this.cacheInvalidation = data.cacheInvalidation;
      this.enterVerificationCode = data.enterVerificationCode;
      if (data && data.isShowEdu === false) {
        this.isShowEdu = data.isShowEdu;
        this.close();
      }
    },
    // 去参加其他活动
    goOtherActivity() {
      this.$emit('goOtherActivity');
    },
    /**
     * 微信登录可以认证：微信学生认证、edu认证2种方式
     * 支付宝登录可以认证：芝麻学生、芝麻医护、芝麻教师、edu、支付宝学生认证、芝麻信用6种方式
     */
    clickCheckIdentity() {
      let params = {
        actionCode: 400080030,
        content: {
          parentPage: 'bigTurntable',
        },
      };
      if (this.pageSource === 'thematicActivity') {
        params.content.parentPage = 'thematicActivity';
      }
      const eventTrackingData = JSON.parse(sessionStorage.getItem('eventTrackingData') || '{}');
      if (eventTrackingData && eventTrackingData.storeCode && eventTrackingData.guideUserId) {
        params.content.activityName = eventTrackingData.activityName;
        params.content.activityType = eventTrackingData.activityType;
        params.content.guideUserId = eventTrackingData.guideUserId;
        params.content.channelCode = eventTrackingData.storeCode;
      } else if (this.storeCode && this.guideUserId) {
        params.content.activityName = this.activityName;
        params.content.activityType = this.activityType;
        params.content.guideUserId = this.guideUserId;
        params.content.channelCode = this.storeCode;
      }
      // 埋码上报
      utils.handleBatchReport(this, params);
      const list = this.identityTypeList;
      const length = this.identityTypeList.length;
      if (length > 0) {
        if (length > 1) {
          let newList = [];
          if (this.loginType === LoginType.Wechat) {
            newList = list.filter((item) => {
              return item === IdentityVerify.weChatSchool || item === IdentityVerify.eduEducation;
            });
          }
          if (this.loginType === LoginType.Alipay) {
            newList = list.filter((item) => {
              return item !== IdentityVerify.weChatSchool;
            });
          }
          if (newList && newList.length > 0) {
            this.isShowGoCheck = false;
            if (newList.length > 1) {
              // 配置多种身份-弹多选身份框
              this.$refs.selectMethods && this.$refs.selectMethods.show();
              this.isShowMask = true;
            } else {
              this.toVerify(newList[0]);
            }
          }
        } else {
          // 只配置一种身份-不弹多选身份框-直接跳转对应的认证
          this.toVerify(list[0]);
          this.isShowGoCheck = false;
        }
      }
    },
    toVerify(type) {
      this.isShowMask = false;
      if (this.loginType === LoginType.Wechat && type === IdentityVerify.weChatSchool) {
        // 跳转微信认证
        this.goCheckIdentity(type);
        this.close();
        return;
      }
      if (
        this.loginType === LoginType.Alipay &&
        [IdentityVerify.student, IdentityVerify.teacher, IdentityVerify.medicalWorkers, IdentityVerify.alipayStudent, IdentityVerify.zhiMaCredit].includes(type)
      ) {
        // 跳转芝麻认证或支付宝学生认证或芝麻信用授权
        this.goCheckIdentity(type);
        this.close();
        return;
      }
      if (type === IdentityVerify.eduEducation) {
        // 跳edu认证
        this.getUserEduIdentity();
      }
    },
    // 获取用户是否绑定过edu身份，绑定过则返回用户信息弹出重新绑定弹框，没绑定过返回空弹出用户教育信息输入弹框
    getUserEduIdentity() {
      this.$api.post({
        sc: 'mobileMarketing',
        url: `edu/certification/get_edu_certification_by_mid`,
        params: {},
        success: (res) => {
          this.isShowMask = true;
          if (res.code === 200) {
            this.isShowEdu = true;
            this.$refs.selectMethods.showAuthenticationMethod = false;
            this.isShowMask = false;
            if (res.result) {
              this.inputInfoPop = false;
              this.cacheInvalidation = true;
              const oldUserInfo = {
                id: res.result.id,
                userName: res.result.userName,
                email: res.result.email,
                identity: res.result.identity,
                university: res.result.university,
              };
              this.oldUserInfo = oldUserInfo;
            } else {
              this.inputInfoPop = true;
              this.cacheInvalidation = false;
            }
          } else {
            Toast(res.message);
          }
        },
      });
    },

    goCheckIdentity(identityType) {
      /**
       * pageSource 页面来源 thematicActivity 专题活动领券 bigTurntable 大转盘活动
       * isClickNextPage 是否点击了下级页面 'true'：点击了下级页面
       */
      console.log(
        '点击去验证',
        this.pageSource,
        this.isClickNextPage,
        identityType,
        this.activityUrlCopy,
        this.activityCode,
        this.clickListId,
        this.clickIndex
      );
      let activityUrlTemp = '';
      if (this.pageSource === 'thematicActivity') {
        // 专题活动点击图片，进入下级页面，相当于子页面去小程序验证身份
        if (this.isClickNextPage === 'true') {
          activityUrlTemp = `${location.origin}/hd/hdmain?activityCode=${this.activityCode}&identityType=${identityType}&isClickNextPage=true&clickListId=${this.clickListId}&clickIndex=${this.clickIndex}`;
        } else {
          // 专题活动直接父页面领券
          activityUrlTemp = `${this.activityUrlCopy}&identityType=${identityType}&isClickNextPage=false&clickListId=${this.clickListId}&clickIndex=${this.clickIndex}`;
        }
      } else if (this.pageSource === 'bigTurntable') {
        // 大转盘--点击参与其他活动，相当于子页面去小程序验证身份
        if (this.isClickNextPage === 'true') {
          activityUrlTemp = `${location.origin}/hd/hdmain?activityCode=${this.activityCode}&identityType=${identityType}&isClickNextPage=true`;
        } else {
          // 大转盘--未点击参与其他活动，直接父页面去小程序验证身份
          activityUrlTemp = `${this.activityUrlCopy}&identityType=${identityType}&isClickNextPage=false`;
        }
      }
      console.log('activityUrlTemp', activityUrlTemp);
      goIdentityVerification(this.loginType, activityUrlTemp);
    },
  },
};
</script>
<style scoped lang="scss">
.tips {
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  .content {
    position: absolute;
    background-color: #ffffff;
    width: 85.333vw;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 1000;
    border-radius: 2.667vw;
    padding: 7.467vw 5vw;
    .title {
      font-size: 16px;
      color: #000000;
      letter-spacing: 0;
      text-align: center;
      line-height: 20px;
      font-weight: 400;
    }
    .button {
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-top: 6.667vw;
      color: #000;
      .one-check {
        width: 52.933vw;
        height: 10.667vw;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .show-other {
        display: flex;
        width: 100%;
        justify-content: space-around;
        .go-other {
          background: #f2f2f2;
          color: #256fff;
        }
        .go-check {
          background: #256fff;
          color: #ffffff;
        }
        .common {
          font-size: 3.733vw;
          border-radius: 5.333vw;
          width: 33.333vw;
          height: 10.667vw;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .button-style {
          width: 52.933vw;
          height: 10.667vw;
          background: #256fff;
          color: #ffffff;
        }
      }
      .left {
        background: #256fff;
        padding: 1.6vw 6.667vw;
        border-radius: 5.333vw;
        font-size: 18px;
        color: #ffffff;
        text-align: center;
        font-weight: 500;
        align-self: center;
      }
      .right {
        background: #256fff;
        border-radius: 40px;
        border-radius: 5.333vw;
        font-size: 3.733vw;
        color: #ffffff;
        text-align: center;
        font-weight: 500;
        align-self: center;
      }
      .right-close {
        color: #256fff;
        background: #f2f2f2;
        width: 52.933vw;
        height: 10.667vw;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .closeImage {
      position: absolute;
      left: 50%;
      top: 122%;
      transform: translate(-50%, -50%);
      z-index: 1000;
      width: 9.6vw;
      height: 9.6vw;
      img {
        width: 7.6vw;
        height: 7.6vw;
      }
    }
  }
}
.maskBgc {
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/dynamicAttr/identityVerifyDialog.vue